<template>
  <div class="province-datasource-dashboard">
    <el-row :gutter="0">
      <el-col :span="8" :class="active == '寻源商品' ?  'active tit' : 'tit'" @click.native="onClick('寻源商品')">
        <div class="title">寻源商品数</div>
        <div class="count">{{explore.onlineCount}}</div>
      </el-col>
      <el-col :span="8" :class="active == '引入商品' ?  'block tit active' : 'block tit'" @click.native="onClick('引入商品')">
        <div class="title">引入商品数</div>
        <div class="count">{{explore.importCount}}</div>
      </el-col>
      <el-col :span="8" :class="active == '地标商品' ?  'block tit active' : 'tit block'" @click.native="onClick('地标商品')">
        <div class="title">地标性商品</div>
        <div class="count">{{explore.iconicCount}}</div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "ProvinceDataSourceDashboard",
  props: ["explore","active"],
  methods: {
      onClick(active) {
          this.$emit("checkTab", active);
      }
  }
};
</script>

<style lang="scss">
.province-datasource-dashboard {
  text-align: center;
  margin-top: 9px;
  .title {
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(132, 135, 145, 1);
    line-height: 20px;
  }

  .count {
    height: 40px;
    font-size: 22px;
    font-family: "DINMedium";
    color: rgba(51, 51, 51, 1);
    line-height: 40px;
  }
  .tit{
    cursor: pointer;
  }
  .active>div{
    color: #1B994F;
  }
}
</style>